import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: ['M7 1h4v5H7V1zM0 1h6v5H0V1zm6 7h9v5H6V8zM0 8h5v5H0V8zm13 7h7v5h-7v-5zM0 15h12v5H0v-5z'],
  height: 20,
  width: 20,
});
